import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { inProgress, isNullOrUndefined } from "../../../../common/utils";
import { InputApiConstants, InputFieldsActions } from "../model";

export function useLoadingInputOptions(triggerApiCall) {
  function isError(error) {
    return !isNullOrUndefined(error);
  }

  function useProgressState(attribute) {
    return useSelector((rootState) => {
      return rootState.inputFields[attribute].progress;
    });
  }

  function useErrorState(attribute) {
    return useSelector((rootState) => {
      return rootState.inputFields[attribute].error;
    });
  }

  const dispatch = useDispatch();

  const officeApiProgress = useProgressState(InputApiConstants.Offices);
  const jobProfileApiProgress = useProgressState(InputApiConstants.JobProfiles);
  const departmentApiProgress = useProgressState(InputApiConstants.Departments);
  const pohApiProgress = useProgressState(InputApiConstants.POHs);
  const miscellaneousApiProgress = useProgressState(InputApiConstants.Miscellaneous);

  useEffect(() => {
    if (triggerApiCall === true) {
      dispatch(InputFieldsActions.getDepartments());
      dispatch(InputFieldsActions.getJobProfiles());
      dispatch(InputFieldsActions.getOffices());
      dispatch(InputFieldsActions.getPOHs());
      dispatch(InputFieldsActions.getMiscellaneous());
    }
  }, []);

  const officeApiError = useErrorState(InputApiConstants.Offices);
  const jobProfileApiError = useErrorState(InputApiConstants.JobProfiles);
  const departmentApiError = useErrorState(InputApiConstants.Departments);
  const pohApiError = useErrorState(InputApiConstants.POHs);
  const miscellaneousApiError = useErrorState(InputApiConstants.Miscellaneous);

  const isInProgress =
    inProgress(officeApiProgress) ||
    inProgress(jobProfileApiProgress) ||
    inProgress(departmentApiProgress) ||
    inProgress(pohApiProgress) ||
    inProgress(miscellaneousApiProgress);

  const isInError =
    isError(officeApiError) ||
    isError(jobProfileApiError) ||
    isError(departmentApiError) ||
    isError(pohApiError) ||
    isError(miscellaneousApiError);
  return {
    isInProgress,
    isInError,
  };
}
